module.exports = __webpack_public_path__ + "static/img/new_btn1.fecd7913.png";